var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddCard = function SvgAddCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "add_card_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#add_card_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 20q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 18V6q0-.824.587-1.412A1.93 1.93 0 0 1 4 4h16q.824 0 1.413.588Q22 5.175 22 6v6H4v6h9q.424 0 .713.288.287.287.287.712 0 .424-.287.712A.97.97 0 0 1 13 20zM4 8h16V6H4zm15 11h-2a.97.97 0 0 1-.712-.288A.97.97 0 0 1 16 18q0-.424.288-.712A.97.97 0 0 1 17 17h2v-2q0-.424.288-.713A.97.97 0 0 1 20 14q.424 0 .712.287.288.288.288.713v2h2q.424 0 .712.288.288.287.288.712 0 .424-.288.712A.97.97 0 0 1 23 19h-2v2q0 .424-.288.712A.97.97 0 0 1 20 22a.97.97 0 0 1-.712-.288A.97.97 0 0 1 19 21z"
  }))));
};
export default SvgAddCard;